import { useEffect, useState } from 'react';

const COPIED_RESET_MS = 2000;

export const useCopiedFeedback = (
  resetMs: number = COPIED_RESET_MS,
): { copied: boolean; markCopied: () => void } => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), resetMs);
    return () => clearTimeout(timer);
  }, [copied, resetMs]);

  return { copied, markCopied: () => setCopied(true) };
};
